exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-digital-tsx": () => import("./../../../src/pages/digital/[...].tsx" /* webpackChunkName: "component---src-pages-digital-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-health-care-provider-tsx": () => import("./../../../src/templates/HealthCareProvider.tsx" /* webpackChunkName: "component---src-templates-health-care-provider-tsx" */)
}

